/**
 * Product Selector Quote Form Module
 * @author Rhys Lloyd
 */

// Utilities
import debug from "debug";
const MODULE_NAME = 'exec';
const log = debug(MODULE_NAME);


// Dependencies
import {MODULE_SELECTOR} from '@core/modules/ps-quote-form/dynamic-load';
import init from '@core/modules/ps-quote-form/index';

/**
 * Run module
 */
export default function exec () {
	log('Running...');

	$(document).ready(() => {
		// Find all elements and operate
		let elements = document.querySelectorAll(MODULE_SELECTOR);
		log('elements:', elements);

		// Backward loops are just faster
		for (let i = elements.length - 1; i >= 0; --i) {
			init(elements[i]);
		}
	});
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/ps-quote-form/exec.js